
<Detail v-if="data" show-footer>
    <template v-slot:header>
        <div class="row">
            <div class="col col-6">
                <h4>{{ $t("buyer") }}</h4>
                <h2>{{ data.name }}</h2>
                <h3>{{ $t("organization_id") | upper }}: {{ data.ico }}</h3>
            </div>
            <div id="suppliers" class="col col-2">
                <h4>{{ $tc("supplier", 2) }}</h4>
                <h2 class="numeric">
                    {{ formatInteger(data.suppliers_count) }}
                </h2>
            </div>
            <div id="period" class="col col-4">
                <h4>{{ $t("period") }}</h4>
                <h2 class="numeric">
                    {{ data.start_date | moment("M/YYYY") }}-{{ data.end_date | moment("M/YYYY") }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:header_small>
        <div class="row no-gutters">
            <div class="col col-8">
                <h2>{{ data.name }}</h2>
            </div>
            <div id="period" class="col col-4">
                <h2 class="numeric">
                    {{ data.start_date | moment("M/YYYY") }}-{{
                        data.end_date | moment("M/YYYY")
                    }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:menu>
        <Menu :nav="nav" current="risks" />
    </template>

    <template v-slot:content>
        <section v-if="data" id="risks_section">
            <color-bubble variant="dark" ratio="half">
                <template v-slot:icon>
                    <b-icon-arrow-up />
                </template>
                <template v-slot:heading>{{
                    $t("overview.risk.short", [$t("risk.level." + data.risk_level_full)])
                }}</template>
                <template v-slot:description>
                    {{ $t("overview.risk.long", {save: formatNumber(data.save)}) }}
                </template>
            </color-bubble>

            <color-bubble
                variant="beige"
                ratio="half"
                class="color_dark_important"
            >
                <template v-slot:icon>
                    <b-icon-hash />
                </template>
                <template v-slot:heading>{{
                    $tc("overview.supplier.short", data.suppliers_risky_count, [
                        formatInteger(data.suppliers_risky_count)
                    ])
                }}</template>
                <template v-slot:description>{{
                    $t("overview.supplier.long", [
                        formatInteger(data.suppliers_count),
                        formatInteger(data.suppliers_risky_count)
                    ])
                }}</template>
            </color-bubble>

            <color-bubble
                variant="beige"
                ratio="half"
                class="color_dark_important"
            >
                <template v-slot:icon>
                    <b-icon-wallet />
                </template>
                <template v-slot:heading>{{
                    $t("overview.sum.short", [formatNumber(data.suppliers_total)])
                }}</template>
                <template v-slot:description>{{ $t("overview.sum.long") }}</template>
            </color-bubble>

            <h5 class="mt-5 mb-3">{{ $t("overview.flags.title") }}</h5>

            <RisksTable
                :flags="data.flags"
                :version="version"
                :clickable-rows="true"
                @row-clicked="(f) => pushFilter({ flag: [{ name: f.name, type: f.type }] })"
            ></RisksTable>
        </section>
    </template>
</Detail>
